import { useMemo, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { useRicercaComuni, BaseAutocompletamento, BaseGridLayout, useFormContext, BaseTextInput, SceltaNazione, ITALY, isItaly as isItaly_fun } from '@lucan/base-ui'

export default function FormComune(props) {
  const {
    nameCap,
    nameComune,
    nameProvincia,
    nameNazione,

    labelComune,
    labelComuneEstero,
    labelNazione,
    labelInserisciCapComune,

    tipoRicercaNascita = false,
    nazioni,
    readOnly,
    propsGrid,
  } = props

  const { watch, setValue, onChange, trigger } = useFormContext()
  const [capWatch, comuneWatch, provinciaWatch, nazioneWatch] = watch(
    [nameCap, nameComune, nameProvincia, nameNazione]
  )

  const isItaly = isItaly_fun(nazioneWatch)
  const {
    optionsComuni,
    pulisciOptionsComuni,
    inAttesaRicercaPerCAP,
    inAttesaRicercaPerNome,
    cercaComuniPerCAP,
    cercaComuniPerNome,
    creaOptionComune,
  } = useRicercaComuni({
    tipoRicercaNascita,
    isItaly,
    readOnly,
    trasformaRisposta: ({ data }) => data
  })

  let opzioneCorrente = null
  if (isItaly && capWatch && comuneWatch && provinciaWatch) {
    opzioneCorrente = creaOptionComune({ cap: capWatch, nome: comuneWatch, provincia: provinciaWatch })
  }

  const opzioniDefinitive = useMemo(() => {
    if (!opzioneCorrente) return optionsComuni
    return [
      opzioneCorrente,
      ...optionsComuni.filter(({ label }) => label !== opzioneCorrente.label)
    ]
  }, [optionsComuni, opzioneCorrente?.label])

  const [inputValue, setInputValue] = useState(opzioneCorrente?.label || '')
  const [inputValueTouched, setInputValueTouched] = useState(false)

  function compilaCampiDaAutocompletamento(opzioneScelta) {
    const { label, comuneCompleto } = opzioneScelta
    const { cap, nome, provincia } = comuneCompleto
    setInputValue(label)
    setValue(nameCap, cap)
    setValue(nameComune, nome)
    setValue(nameProvincia, provincia)
    setValue(nameNazione, ITALY)
    onChange()
    trigger([nameCap, nameComune, nameProvincia])
    pulisciOptionsComuni()
  }

  function pulisciCampi() {
    setInputValue('')
    setInputValueTouched(true)
    setValue(nameCap, '')
    setValue(nameComune, '')
    setValue(nameProvincia, '')
  }

  const propsComuni = { readOnly }

  const shrinkProp = { InputLabelProps: { shrink: true } }

  const {
    formState: { isSubmitted }
  } = useFormContext()
  
  return (
    <BaseGridLayout {...propsGrid}>
      <SceltaNazione
        label={labelNazione} name={nameNazione}
        options={nazioni}
        onChange={pulisciCampi}
        {...(nazioneWatch && shrinkProp)}
        {...propsComuni}
        required
        webComponentFix
      />

      <BaseAutocompletamento
        label={labelComune}
        nonUsareHookForm
        options={opzioniDefinitive}
        propsAutocomplete={{
          inputValue,
          onInputChange: (_, inputValue, reason) => {
            if (reason === 'reset') return
            if (!inputValue) {
              pulisciCampi()
              trigger([nameCap, nameComune, nameProvincia])
              return
            }
            setInputValue(inputValue)
            setInputValueTouched(true)
            if (/\d+/.test(inputValue)) {
              cercaComuniPerCAP(inputValue)
            } else {
              cercaComuniPerNome(inputValue)
            }
          },
          onChange: (_, value) => compilaCampiDaAutocompletamento(value),
          noOptionsText: labelInserisciCapComune,
        }}
        {...((inAttesaRicercaPerCAP || inAttesaRicercaPerNome) && {
          InputProps: {
            endAdornment: <CircularProgress size={32} color='secondary' />
          }
        })}
        {...propsComuni}
        hidden={!isItaly}
        required // nonUsareHookForm => required serve solo per appendere "*" alla label
        error={(inputValueTouched || isSubmitted) && !(capWatch && comuneWatch && provinciaWatch)}
        messaggioAiuto=''
        webComponentFix
      />

      <BaseTextInput
        label={labelComuneEstero} name={nameComune}
        {...(comuneWatch && shrinkProp)}
        {...propsComuni}
        hidden={isItaly}
        required
      />
      <BaseTextInput
        name={nameCap}
        {...(capWatch && shrinkProp)}
        {...propsComuni}
        hidden
      />
      <BaseTextInput
        name={nameProvincia}
        {...(provinciaWatch && shrinkProp)}
        {...propsComuni}
        hidden
      />
    </BaseGridLayout>
  )
}